var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 202.35 202.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cecece;}.cls-2{fill:#001328;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 101.18,
    cy: 101.18,
    r: 101.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.43,102.61c-1.16,7.72-2.3,15.2-3.41,22.68-.3,2-1.37,3-3.43,3.54a98.94,98.94,0,0,1-45.85.22c-2.25-.52-3.43-1.48-3.95-3.86a101,101,0,0,1,.48-45.5,5.22,5.22,0,0,1,3.17-3.16,85.58,85.58,0,0,1,46.73.23A4.77,4.77,0,0,1,127,79.84C128.31,87.41,129.32,95,130.43,102.61Zm-19.61,13c2.59-.34,3.82-1.44,3.22-3.71a11.27,11.27,0,0,0-1.76-3.93c-2.7-3.51-2-6.92-.13-10.42a11.49,11.49,0,0,0,1.36-2.94,37.88,37.88,0,0,0,.41-4.66c-1.65,0-3.64-.6-4.9.1-5.64,3.12-11,3.52-16.6-.11-1.06-.69-3.6-.89-4.12-.24a4.89,4.89,0,0,0-.53,4.42c3.22,5.69,3.91,11.11,0,16.81a4,4,0,0,0,.34,3.8c.73.73,2.59.67,3.86.44a12.27,12.27,0,0,0,4-1.71c3.08-1.88,6.06-1.74,9.21-.12A57,57,0,0,0,110.82,115.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.41,115.07c-4.81,24.51-24.8,42.38-46.68,46.92,6.54-7.05,11.84-14.63,14.59-23.44,1.7-5.45,4.79-8.07,9.92-9.85A62.67,62.67,0,0,0,159.41,115.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88,162.06c-22.39-4.44-43.59-25.78-46.21-46.48a22.48,22.48,0,0,1,2,1.47c6.87,6.32,15,10.37,23.77,13.32a6.78,6.78,0,0,1,4.78,4.71C76.49,147,81.14,154.86,88,162.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.32,90.09C47.89,66.17,63.42,50.4,88.2,43.28c-3,4-5.88,7.53-8.38,11.37-2,3.11-4.29,6.37-5.15,9.88C72.87,71.87,68.11,75,61.48,77.8,54.21,80.87,47.82,86,41.32,90.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.05,91.3c-7.47-8-16.28-12.75-25.85-16.28-1.22-.45-2.82-1.29-3.21-2.34-3.89-10.42-8.76-20.25-16.83-28.53C134.26,47.6,156.06,69,159.05,91.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.91,156.39,75.79,134.24l.8-.89a104.78,104.78,0,0,0,48.34-.42c-3.15,8.61-6.73,16.33-13,23.11-2.1-6.49-6.15-9.95-12.93-9.26-5.53.56-8.59,3.86-9.77,9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.06,49.43q6.22,10.93,12.44,21.86l-.87.86A100.23,100.23,0,0,0,76.86,72c.52-5.36,7.25-17.42,12.39-22.21,1.67,5.83,5.24,9.41,11.48,9.44S110.14,55.22,113.06,49.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.19,79.17c-.73,8.19-1.91,16-2,23.74s1.08,15.29,1.71,23.16a60.52,60.52,0,0,1-21.29-11.42c6.5-2.25,10-6.3,9.34-13-.53-5.51-4.14-8.4-9.49-10A59.46,59.46,0,0,1,69.19,79.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.49,78.73l21,12-.22,1c-6.2,1.71-10,5.36-9.76,12,.15,5,2.81,8,9.23,10.66-3.35,4.17-13.25,9.76-21.42,11.93a106.91,106.91,0,0,0,.31-46.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.11,164.09c-4.1-.11-7.12-3-6.94-6.72a7.33,7.33,0,0,1,14.63.27C107.73,161.28,104.26,164.2,100.11,164.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.05,103.36a7,7,0,0,1-6.77,7,6.89,6.89,0,0,1-6.6-7.13c.06-3.94,3-7.48,6.34-7.51C49.8,95.68,53.11,99.27,53.05,103.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.13,103.18c0,4-3,7.35-6.47,7.26a7.29,7.29,0,0,1,0-14.58C158.11,95.86,161.16,99.31,161.13,103.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.4,41.65c4.16,0,7.48,3,7.46,6.68s-3.45,6.74-7.48,6.63-7.24-3.47-7.09-7.13C93.43,44.41,96.65,41.61,100.4,41.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.51,94.84c5.52,2.69,10.77,3.24,16.41-.36-3.36,5.36-3.8,10.46-.07,15.78-5.7-3.24-11.09-3.31-16.68.38C95.73,105.29,96.26,100.28,92.51,94.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingPng);
export default __webpack_public_path__ + "static/media/Marketing PNG.63ded8d3a8127c61b13784cafca6be4a.svg";
export { ForwardRef as ReactComponent };